// extracted by mini-css-extract-plugin
export default {"descriptionLabel":"styles_descriptionLabel__88iJ8"};